import { dateRangeData } from "../../pages/Dashboard/dbConstants";
import {
  ADD_ACTIONABLE_POP_UP,
  ADD_CHARGER_IDS,
  ADD_CHARGER_TO_LOCATION_MAP,
  ADD_HOST_IDS,
  ADD_LOCATION_IDS,
  ADD_TOAST_MESSAGE,
  CHANGE_DATERANGE,
  CHANGE_LOCATION,
  CHANGE_PROJECT,
  POPUP_CONFIRM,
  REMOVE_ACTIONABLE_POP_UP,
  REMOVE_TOAST_MESSAGE,
  RESET_FILTER,
  RESET_REPORT_DATA,
  UPDATE_REPORT_DATA,
} from "./actionTypes";

// export const changeDateRange = (payload) => {
//   return { type: CHANGE_DATERANGE, payload: payload };
// };
// export const changeLocation = (payload) => {
//   return { type: CHANGE_LOCATION, payload: payload };
// };

// export const changeProject = (payload) => {
//   return { type: CHANGE_PROJECT, payload: payload };
// };

export const resetFilter = () => ({
  type: RESET_FILTER,
});

export const addToastMessage = (toastDetails) => {
  return { type: ADD_TOAST_MESSAGE, payload: toastDetails };
};

export const removeToastMessage = (id) => {
  return { type: REMOVE_TOAST_MESSAGE, payload: id };
};

export const successToast = (toastDetails) => {
  return {
    type: ADD_TOAST_MESSAGE,
    payload: { type: "success", ...toastDetails },
  };
};

export const failureToast = (toastDetails) => {
  return {
    type: ADD_TOAST_MESSAGE,
    payload: { type: "failure", ...toastDetails },
  };
};

export const warningToast = (toastDetails) => {
  return {
    type: ADD_TOAST_MESSAGE,
    payload: { type: "warning", ...toastDetails },
  };
};

export const errToast = (toastDetails) => {
  return {
    type: ADD_TOAST_MESSAGE,
    payload: { type: "error", ...toastDetails },
  };
};


// actionable pop up
export const addActionablePopUp = (popUpDetails) => {
  return { type: ADD_ACTIONABLE_POP_UP, payload: popUpDetails };
};

export const warningPopUp = (popUpDetails) => {
  return {
    type: ADD_ACTIONABLE_POP_UP,
    payload: { type: "Warning", ...popUpDetails },
  };
};

export const popUpConfirm = (id, type) => {
  return {
    type: POPUP_CONFIRM,
    payload: { id, type },
  };
};
export const removeActionablePopUp = (id) => {
  return { type: REMOVE_ACTIONABLE_POP_UP, payload: id };
};

// Charger Ids and location Ids
export const addChargerToLocationMap = (locationId) => {
  return { type: ADD_CHARGER_TO_LOCATION_MAP, payload: locationId };
};

// report data:
export const updateReportData = (reportData)=>{
  return { type:UPDATE_REPORT_DATA, payload: reportData}
}

export const resetReportData = ()=>{
  return { type:RESET_REPORT_DATA}
}